<form [formGroup]="vehicleForm()" (ngSubmit)="submit()" [class.vehicle-form-mobile]="appSettings.isMobile()">

  <div class="row g-3 mb-3">
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Patente</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <input type="text" class="form-control" formControlName="plate">
        } @else {
          <div class="vehicle-field-value">{{ displayValue(vehicleForm().get('plate')?.value) }}</div>
        }
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Año</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <input type="number" class="form-control" formControlName="year" [min]="minYear" (change)="onYearChange()">
        } @else {
          <div class="vehicle-field-value">{{ displayValue(vehicleForm().get('year')?.value) }}</div>
        }
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Marca</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <ng-select [items]="brands" bindLabel="name" bindValue="code" placeholder="Seleccione una marca"
            (change)="onBrandChange()" formControlName="brandCode">
          </ng-select>
        } @else {
          <div class="vehicle-field-value">{{ displayValue(findBrand(vehicleForm().get('brandCode')?.value)) }}</div>
        }
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Modelo</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <ng-select [items]="models" bindLabel="name" bindValue="code" placeholder="Seleccione un modelo"
            formControlName="modelCode" (change)="onModelChange()">
          </ng-select>
        } @else {
          <div class="vehicle-field-value">{{ displayValue(findModel(vehicleForm().get('modelCode')?.value)) }}</div>
        }
      </div>
    </div>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Color</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <input type="text" class="form-control" formControlName="color">
        } @else {
          <div class="vehicle-field-value">{{ displayValue(vehicleForm().get('color')?.value) }}</div>
        }
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Número de motor</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <input type="text" class="form-control" formControlName="vin">
        } @else {
          <div class="vehicle-field-value">{{ displayValue(vehicleForm().get('vin')?.value) }}</div>
        }
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Kilometraje</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <input type="number" class="form-control" formControlName="km">
        } @else {
          <div class="vehicle-field-value">{{ displayValue(vehicleForm().get('km')?.value) }}</div>
        }
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Transmisión automática</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <div class="form-check mt-2">
            <input type="checkbox" class="form-check-input" id="vehicleIsTransmissionAutomatic" formControlName="isTransmissionAutomatic">
            <label class="form-check-label" for="vehicleIsTransmissionAutomatic">Automática</label>
          </div>
        } @else {
          <div class="vehicle-field-value">{{ vehicleForm().get('isTransmissionAutomatic')?.value ? 'Sí' : 'No' }}</div>
        }
      </div>
    </div>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Valor comercial</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <input type="text" class="form-control" formControlName="commercialValue" appNumberFormat>
        } @else {
          <div class="vehicle-field-value">{{ displayValue(vehicleForm().get('commercialValue')?.value) }}</div>
        }
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="form-group vehicle-field">
        <label class="form-label">Valor</label>
        @if (mode() == FormMode.CREATE || mode() == FormMode.EDIT) {
          <input type="text" class="form-control" formControlName="value" appNumberFormat>
        } @else {
          <div class="vehicle-field-value">{{ displayValue(vehicleForm().get('value')?.value) }}</div>
        }
      </div>
    </div>
  </div>

</form>
